import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { redemptionApi, type ClaimAnonymousResponse } from '../services/redemption';
import { collectTokens, removeByToken } from '../utils/anonymousRedemptions';

const EMPTY: ClaimAnonymousResponse = {
  results: [],
  claimedCount: 0,
  alreadyOwnedCount: 0,
  invalidCount: 0,
};

/**
 * 一键认领：把本浏览器匿名 token 转户到当前登录账号。
 * 横幅与 Redeem「待认领」按钮共用。成功后按 token 清理本地记录并刷新我的数据集。
 */
export function useClaimAnonymous() {
  const queryClient = useQueryClient();
  const claim = useCallback(
    async (tokens?: string[]): Promise<ClaimAnonymousResponse> => {
      const list = tokens && tokens.length ? tokens : collectTokens();
      if (!list.length) return EMPTY;
      const { data } = await redemptionApi.claimAnonymous(list);
      // 三种状态都清本地：claimed 已转户、invalid 已失效、alreadyOwned 已在账号
      for (const r of data.results) removeByToken(r.token);
      queryClient.invalidateQueries({ queryKey: ['my-entitlements'] });
      return data;
    },
    [queryClient],
  );
  return { claim, hasPending: () => collectTokens().length > 0 };
}
